module.exports = __webpack_public_path__ + "images/icons_v2/edit-outlined-de593368.svg";